import { useState } from 'react';
import Map, { Marker } from 'react-map-gl';
import ReactPlayer from 'react-player';
import 'mapbox-gl/dist/mapbox-gl.css';

const BURJ_KHALIFA = {
  latitude: 25.149477752640795,
  longitude: 55.19491212708536
};

const MAPBOX_TOKEN = 'pk.eyJ1IjoiYXJtYW5kZHAiLCJhIjoiY2locXUzMjNuMDAwMnZkbTNyaXNuOHI3NCJ9.3NlM4LO01_hdImvtgAQLew';

function App() {
  const [showFullScreen, setShowFullScreen] = useState(false);
  
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowFullScreen(true);
  };
  
  return (
    <div>
      <Map
        initialViewState={{
          longitude: BURJ_KHALIFA.longitude,
          latitude: BURJ_KHALIFA.latitude,
          zoom: 13
        }}
        style={{ width: '100vw', height: '100vh' }}
        mapStyle="mapbox://styles/armanddp/cm6m0c18500j701qr1gxbe4dy/draft"
        mapboxAccessToken={MAPBOX_TOKEN}
      >
        <Marker
          longitude={BURJ_KHALIFA.longitude}
          latitude={BURJ_KHALIFA.latitude}
        >
          <div 
            className={`
              transition-all duration-300 ease-in-out relative
              ${showFullScreen ? 
                'fixed inset-0 z-50 flex items-center justify-center' : 
                'w-32 h-32 rounded-full overflow-hidden cursor-pointer border-2 border-white shadow-lg'
              }
            `}
          >
            {showFullScreen && (
              <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
            )}
            <div 
              className={`
                relative overflow-hidden
                ${showFullScreen ? 
                  'w-[80vw] h-[80vh] bg-black/80 rounded-lg' : 
                  'w-full h-full rounded-full'
                }
              `}
            >
              {/* Click overlay only in small mode */}
              {!showFullScreen && (
                <div 
                  className="absolute inset-0 z-20"
                  onClick={handleClick}
                />
              )}
              
              {/* Player wrapper */}
              <div className="absolute inset-0">
                <ReactPlayer
                  url="https://youtu.be/OywxtPtNr0I"
                  width={showFullScreen ? "100%" : "200%"}
                  height={showFullScreen ? "100%" : "200%"}
                  playing
                  muted={!showFullScreen}
                  loop
                  controls={false}
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: showFullScreen ? 
                      'translate(-50%, -50%)' : 
                      'translate(-50%, -50%) scale(2.5)',
                    transition: 'all 0.3s ease-in-out',
                    pointerEvents: showFullScreen ? 'auto' : 'none'
                  }}
                />
              </div>

              {showFullScreen && (
                <button 
                  className="absolute -top-4 -right-4 bg-white px-4 py-2 rounded-full shadow-lg z-30"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowFullScreen(false);
                  }}
                >
                  Close
                </button>
              )}
            </div>
          </div>
        </Marker>
      </Map>
    </div>
  );
}

export default App;